'use client';

import type { ReactNode } from 'react';

import { useState } from 'react';

import Box from '@mui/material/Box';

import { RADIUS, SHADOW } from 'src/theme/ui-tokens';

import { FilterAccordionSection } from './filter-accordion-section';

/**
 * 필터 **섹션 카드의 껍데기** — 흰 면 · 테두리 · 살짝 뜬 그림자.
 * 🔑 사이드바 카드(`FilterBasic`)와 필터 판의 섹션 카드(`FilterSectionCard`)가 이 한 벌을 쓴다 — 따로 그리면 둘이 어긋난다.
 */
export const FILTER_CARD_SX = {
  bgcolor: 'background.paper',
  borderRadius: RADIUS.lg,
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: SHADOW.raised,
  height: 'fit-content',
  overflow: 'hidden',
} as const;

/**
 * **필터 섹션 카드 하나** — 제목 · 지금 요약 · 「전체 해제」 · 접기, 그 아래 고르는 칸.
 *
 * ```
 *   ┌ 국가            한국 · 전체 해제  ˄ ┐
 *   │ (KR 1.3만)(US 1만)(JP 2,861) …     │
 *   └────────────────────────────────────┘
 * ```
 *
 * 🔑 사이드바 섹션(`FilterChannelSection` …)과 **같은 머리**(`FilterAccordionSection`)·같은 카드(`FILTER_CARD_SX`)다 —
 *   필터 판 안에서 사이드바 섹션과 화면 갈래 섹션이 한 모양으로 선다.
 * 🔑 펼침은 이 카드가 쥔다(처음엔 펼침) — 값은 부르는 쪽 것이다.
 * @param onClearAll 주면 머리에 되돌리기 단추가 선다(걸린 것이 있을 때만 부른다)
 * @param clearLabel 그 단추의 말 — 없으면 「전체 해제」
 */
export function FilterSectionCard({
  title,
  summary,
  onClearAll,
  clearLabel = '전체 해제',
  children,
}: {
  title: ReactNode;
  /** 지금 걸린 것의 요약 — 「전체」 · 「3개 선택」 · 「한국」 */
  summary?: ReactNode;
  onClearAll?: (() => void) | null;
  clearLabel?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(true);

  return (
    <Box sx={FILTER_CARD_SX}>
      <Box sx={{ py: 0.5 }}>
        <FilterAccordionSection
          title={title}
          countLabel={summary}
          isOpen={open}
          onToggle={() => setOpen((prev) => !prev)}
          headerAction={onClearAll ? { label: clearLabel, pressed: false, onClick: onClearAll } : null}
        >
          <Box sx={{ px: 0.5 }}>{children}</Box>
        </FilterAccordionSection>
      </Box>
    </Box>
  );
}
